import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { LOGO_MARK } from "../data/eventData";

export default function StickyCTA({ onCTA }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0, x: "-50%" }}
          animate={{ y: 0, opacity: 1, x: "-50%" }}
          exit={{ y: 90, opacity: 0, x: "-50%" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-1/2 z-50"
          data-testid="sticky-cta-bar"
        >
          <div className="flex items-center gap-3 sm:gap-4 rounded-full glass-strong border border-white/15 pl-3 pr-2 py-2 shadow-[0_20px_60px_rgba(0,10,30,0.6)]">
            <img src={LOGO_MARK} alt="" className="h-6 w-auto shrink-0" aria-hidden="true" />
            <span className="hidden md:block font-sans text-xs text-white/60 whitespace-nowrap">
              03 a 05 de março · Florianópolis
            </span>
            <button
              onClick={onCTA}
              className="group flex items-center gap-3 rounded-full bg-gradient-to-r from-brand-blue to-brand-cyan pl-5 pr-1.5 py-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.45),0_16px_40px_rgba(3,10,26,0.60)] hover:-translate-y-0.5 transition-all duration-300"
              data-testid="sticky-cta-button"
            >
              <span className="font-display font-bold uppercase tracking-[0.05em] text-brand-deep text-[11px] sm:text-xs whitespace-nowrap">
                Quero garantir minha inscrição
              </span>
              <span className="h-8 w-8 rounded-full bg-brand-deep flex items-center justify-center overflow-hidden shrink-0">
                <ArrowRight size={14} className="text-brand-cyan arrow-flow" />
              </span>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
